import { useState } from 'react';
import { apiPost } from '../api/api';
import useAuth from '../hooks/useAuth';

export default function Login() {
    const { login } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [err, setErr] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async e => {
        e.preventDefault();
        setErr('');
        setLoading(true);
        try {
            const res = await apiPost('/login.php', { username, password });
            if (res.status !== 'ok') setErr('Špatné přihlašovací údaje');
            else login(res.user, res.token);
        } catch {
            setErr('Chyba přihlášení');
        }
        setLoading(false);
    };

    return (
        <div className="auth-wrap">
            <h1>Fantasy World Battle</h1>
            <form onSubmit={submit} className="auth-form">
                <input placeholder="Uživatelské jméno" value={username} onChange={e=>setUsername(e.target.value)} />
                <input placeholder="Heslo" type="password" value={password} onChange={e=>setPassword(e.target.value)} />
                <button disabled={loading}>{loading ? 'Přihlašuji...' : 'Přihlásit se'}</button>
                {err ? <div className="auth-error">{err}</div> : null}
            </form>
        </div>
    );
}
